// extracted by mini-css-extract-plugin
export var active = "Sidebar-module--active--CWAHF";
export var category = "Sidebar-module--category--c5Jdo";
export var icon = "Sidebar-module--icon--QxP66";
export var menu = "Sidebar-module--menu--yrQje";
export var opened = "Sidebar-module--opened--DtnQI";
export var title = "Sidebar-module--title--lQ6UL";